import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSelect} from '@angular/material/select';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {FormControl} from '@angular/forms';
import {Crops} from '@entities/canh-tac/canh-tac.model';
import {IUser, UserService} from '@app/core';
import {CanhTacService} from '@entities/canh-tac/canh-tac.service';
import {JhiEventManager} from 'ng-jhipster';

@Component({
  selector: 'app-canh-tac-manager-dialog',
  templateUrl: './canh-tac-manager-dialog.component.html',
})
export class CanhTacManagerDialogComponent implements OnInit {
  isSaving: boolean;
  lo: Crops;
  users: IUser[];
  selectMutilData = new FormControl();
  selectedValue = [];
  @ViewChild('allSelected', {static: false}) private allSelected: MatSelect;

  constructor(
    private dialogRef: MatDialogRef<CanhTacManagerDialogComponent>,
    private titleService: Title,
    private translate: TranslateService,
    private userService: UserService,
    private canhTacService: CanhTacService,
    private eventManager: JhiEventManager,
  ) {}
  save() {
    const valueUpdate = {
      cropId: this.lo.id,
      detailUserIds: [...this.selectMutilData.value],
    };
    this.canhTacService.updateCuratorUser(valueUpdate).subscribe((response) => {
      this.eventManager.broadcast({
        name: 'loDetailModification',
        content: 'Lo',
      });
      this.dialogRef.close(true);
    });
  }
  ngOnInit() {
    if (this.lo.id !== null && this.lo.tbDetailUsers.length > 0) {
      this.selectedValue = this.lo.tbDetailUsers.map((a) => a.id);
    }
    this.userService.getListDetailUser().subscribe((res: any) => {
      this.users = res.body ? res.body : [];
    });
  }
}

@Component({
  selector: 'app-canh-tac-manager-manager',
  template: '',
})
export class CanhtacManagerPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<CanhTacManagerDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({lo}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(CanhTacManagerDialogComponent, {
          disableClose: true,
          width: '480px',
        });
        this.dialogRef.componentInstance.lo = lo;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.canh-tac.canh-tac-manager-dialog.Danh sách lô_title',
      ),
    );
    this.dialogRef = null;
  }
}
